import { parseDateToString } from "content/Event/util";
export const APPROVAL_REQUEST = (event, timezoneString) => "Please review, edit, approve or disapprove this event by " + parseDateToString(event.publishAt, timezoneString);